import MapPropertyCard from 'components/properties/PropertyCard/MapPropertyCard';
import { BorrowerPropertyType } from 'types/debt-types';

const LendMapPropertyCard = ({
  borrowerProperty,
}: {
  borrowerProperty: BorrowerPropertyType;
}) => {
  return (
    <MapPropertyCard
      property={borrowerProperty.property}
      price={borrowerProperty.loanAmount}
    />
  );
};

export default LendMapPropertyCard;
